/**
 * @file ChartPie
 * @author zhuping04
 */

import _ from 'lodash';
import React from 'react';

import {createChartPie} from '../chartUtil';
import Chart from './Chart';

interface ChartPieMap {
    name: string;
    value: string;
}

export interface ChartPieProps {
    title?: string;
    width?: number | string;
    height?: number | string;
    data?: any[];
    keyMap?: ChartPieMap;
    direction?: string;
    options?: object;
}

const ChartPie = (props: ChartPieProps) => {
    const {
        title,
        data = [],
        keyMap = {name: 'name', value: 'value'},
        direction = 'default',
        options = {},
        width = '100%',
        height = 400
    } = props;
    const option = createChartPie({
        title,
        direction,
        data: _.map(data, o => ({
            name: o[(keyMap as ChartPieMap).name],
            value: o[(keyMap as ChartPieMap).value]
        })),
        options
    });

    return (
        <Chart option={option} width={width} height={height} autoResize />
    );
};

export default ChartPie;